import React from 'react';
import ScheduleCalendarSection from './ScheduleCalendarSection';

export default function DriverScheduleSection({
  driverId = null,
  driverName = '',
  embedded = false,
  selfView = false,
  isMobile = false,
}) {
  const scheduleUrl = selfView
    ? '/drivers/schedule/'
    : driverId
      ? `/drivers/${driverId}/schedule/`
      : null;

  return (
    <ScheduleCalendarSection
      scheduleUrl={scheduleUrl}
      resourceName={driverName}
      subtitle={
        selfView
          ? 'Your upcoming deliveries by day.'
          : undefined
      }
      entityLabel="driver"
      embedded={embedded}
      showVehicle
      enabled={selfView || !!driverId}
      canAddPhotos={false}
      isMobile={isMobile}
    />
  );
}
